import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import { Routes, Route, HashRouter, Navigate, BrowserRouter } from "react-router-dom";
import Dashboard from './components/dashboard';
import Login from './components/login';
import Booking from './components/masters/Booking';
import Slot from './components/masters/Slot';
import DonationDetail from './components/masters/DonationDetail';
import EventDetail from './components/masters/EventDetail';
import BannerDetail from './components/masters/BannerDetail';
import News from './components/masters/News';
import DonationAmountList from './components/masters/DonationAmountList';
import BookingDetailByLoginId from './components/masters/BookingDetailByLoginId';
import UserList from './components/UserList';
import DonationDetailByLoginId from './components/masters/DonationDetailByLoginId';
import Notification from './components/Notification';
import YblSlot from './components/masters/YblSlot';
import Sponsor from './components/masters/Sponsor';
import PlayerList from './components/PlayerList';
import VanuePartnerList from './components/VanuePartnerList';
import Sports from './components/masters/Sports';
import Teams from './components/masters/teams';
import Players from './components/masters/Players';
import Matches from './components/masters/Matches';
import Tournaments from './components/masters/Tournaments';
import Venues from './components/masters/Venues';
import BookingSlot from './components/masters/BookingSlot';
import BoardMember from './components/masters/BoardMember';
import Enquiry from './components/Enquiry';
import PartnerPlayers from './components/Partners/Players';
import PlayerRank from './components/Players/playerRank';
import AdminPartners from './components/Partners/partners';
import { ShopProvider } from './Context/ShopProvider';
import CricketTeam from './components/ycl/cricketTeam';
import PassOrderList from './components/buzzercarnival/PassOrderList';
import Tournments from './components/ycl/Tournments';
import MatchesList from './components/ycl/MatchesList';
import MatchStatusById from './components/ycl/MatchStatusById';
import TeamByCaptain from './components/ycl/TeamByCaptain';
import IndividualPlayer from './components/ycl/IndividualPlayer';
import YclSponsorCategory from './components/ycl/YclSponsorCategory';
import YclSponsors from './components/ycl/YclSponsors';
import YclBanner from './components/ycl/YclBanner';
import WebLogo from './components/ycl/WebLogo';
import SocialMedia from './components/ycl/SocialMedia';

const ProtectedRoute = ({ element }) => {
  const isAuthenticated = localStorage.getItem("isLoggedIn");
  if (!isAuthenticated) {
    return <Navigate to="/" />;
  }
  return element;
};

function App() {
  return (
    <ShopProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />

          <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} />} />
          <Route path="/booking" element={<ProtectedRoute element={<Booking />} />} />
          <Route path="/booking-slot" element={<ProtectedRoute element={<BookingSlot />} />} />
          <Route path="/slot" element={<ProtectedRoute element={<Slot />} />} />
          <Route path="/donation-detail" element={<ProtectedRoute element={<DonationDetail />} />} />
          <Route path="/event-detail" element={<ProtectedRoute element={<EventDetail />} />} />
          <Route path="/banner-detail" element={<ProtectedRoute element={<BannerDetail />} />} />
          <Route path="/news" element={<ProtectedRoute element={<News />} />} />
          <Route path="/amount-detail" element={<ProtectedRoute element={<DonationAmountList />} />} />
          <Route path="/booking-detail/:id" element={<ProtectedRoute element={<BookingDetailByLoginId />} />} />
          <Route path="/user-list" element={<ProtectedRoute element={<UserList />} />} />
          <Route path="/player-list" element={<ProtectedRoute element={<PlayerList />} />} />
          <Route path="/vanue-partner-list" element={<ProtectedRoute element={<VanuePartnerList />} />} />
          <Route path="/donation-detail/:id" element={<ProtectedRoute element={<DonationDetailByLoginId />} />} />
          <Route path="/notification" element={<ProtectedRoute element={<Notification />} />} />
          <Route path="/ybl-slot" element={<ProtectedRoute element={<YblSlot />} />} />
          <Route path="/sponsor" element={<ProtectedRoute element={<Sponsor />} />} />
          <Route path="/board-member" element={<ProtectedRoute element={<BoardMember />} />} />
          <Route path="/sports" element={<ProtectedRoute element={<Sports />} />} />
          <Route path="/teams" element={<ProtectedRoute element={<Teams />} />} />
          <Route path="/players" element={<ProtectedRoute element={<Players />} />} />
          <Route path="/matches" element={<ProtectedRoute element={<Matches />} />} />
          <Route path="/tournaments" element={<ProtectedRoute element={<Tournaments />} />} />
          <Route path="/venues" element={<ProtectedRoute element={<Venues />} />} />
          <Route path="/enquiry" element={<ProtectedRoute element={<Enquiry />} />} />
          <Route path="/rank" element={<ProtectedRoute element={<PlayerRank />} />} />
          <Route path="/partners" element={<ProtectedRoute element={<AdminPartners />} />} />
          <Route path="/team/:id" element={<ProtectedRoute element={<TeamByCaptain />} />} />
          <Route path="/individual-player" element={<ProtectedRoute element={<IndividualPlayer />} />} />

          {/* Partners Role */}
          <Route path="/partner-players" element={<ProtectedRoute element={<PartnerPlayers />} />} />

          <Route path="/cricket-teams" element={<ProtectedRoute element={<CricketTeam />} />} />
          <Route path="/cricket-teams/:id" element={<ProtectedRoute element={<CricketTeam />} />} />

          <Route path="/passorderlist" element={<ProtectedRoute element={<PassOrderList />} />} />
          <Route path="/tournament" element={<ProtectedRoute element={<Tournments />} />} />
          <Route path="/matches-list" element={<ProtectedRoute element={<MatchesList />} />} />
          <Route path="/matches-list/:id" element={<ProtectedRoute element={<MatchesList />} />} />

          <Route path="/matches-status/:id" element={<ProtectedRoute element={<MatchStatusById />} />} />

          <Route path="/sponsor-category" element={<ProtectedRoute element={<YclSponsorCategory />} />} />
          <Route path="/ycl-sponsor" element={<ProtectedRoute element={<YclSponsors />} />} />
          <Route path="/ycl-banner" element={<ProtectedRoute element={<YclBanner />} />} />
          <Route path="/web-logo" element={<ProtectedRoute element={<WebLogo />} />} />
          <Route path="/social-media" element={<ProtectedRoute element={<SocialMedia />} />} />

          <Route path="*" element={<h1>404 - Page Not Found</h1>} />
        </Routes>
      </BrowserRouter>
    </ShopProvider>
  );
}

export default App;
